<sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="true"></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '95vh'}" styleClass="custombar1">
  <div class="container-fluid " *ngIf="isLoaded()">
    <div class="row">
      <div class="col-12">
        <p-panel [toggleable]="true" [collapsed]="false">
          <p-header>
            <span> <i class="fa fa-file" aria-hidden="true"></i> {{'General.filters'|translate}}</span>
          </p-header>
          <div class="col-12 ">
            <formPlyca #formPlycaRef1 [formConfig]="formConfig1" *ngIf="formConfig1" [manageWaitService]=false>
            </formPlyca>
          </div>
          <div class=" col-12 text-right ">
            <button class="btn btn-sm btn-secondary" (click)="this.clearFilter()"
              title="{{ 'General.reset.filters' | translate}}">
              <i class="fas fa-undo" aria-hidden="true"></i> <span> {{ 'General.reset.filters' | translate}}</span>
            </button>
            <!--button class="btn btn-sm btn-primary ml-2" (click)="this.loadData()"
              title="{{ 'General.search.text' | translate}}">
              <i class="fas fa-search" aria-hidden="true"></i> <span> {{ 'General.search.text' | translate}}</span>
            </button-->
          </div>
        </p-panel>
      </div>
    </div>
    <div class="row m-t-md">
      <div class="col-12">
        <p-panel [toggleable]="false" [collapsed]="false" [styleClass]="' scroll-x'">
          <p-header>
            <span class="label label-default float-right">{{ 'Tasks.showing' | translate }} {{elements ? elements.length
              : '0'}} </span>
          </p-header>
          <div class="row mt-3" *ngIf="this.procurementprojectLot && !this.procurementprojectAM">
            <div class="col-12">
              <p-checkbox name="calculateTAX" label="Cálculo automático totales" [(ngModel)]="calculateTAX"
                (onChange)="onChangeCalculateTAX($event.checked,elements)" binary="true">
              </p-checkbox>
            </div>
          </div>

          <div class="row">
            <div class="col-12 ">
              <div class="alert alert-info col-12" role="alert" *ngIf="!elements || elements.length===0">
                <span style="line-height: 2em;"><i class="fa fa-1-5x fa-info-circle mr-2" aria-hidden="true"></i>{{
                  'General.noData' | translate }}</span>
              </div>
              <div *ngIf="elements && elements.length >0">
                <p-table [value]="filteredElements" [rows]="defaultNumberRows" [paginator]="true" [pageLinks]="4"
                  [rowsPerPageOptions]="rowsPerPageOptions" [responsive]="false" class="col-12" dataKey="identifier"
                  editMode="row" [first]="lastPageFirstRecordIndex" (onPage)="onPageChange($event)" [scrollable]="false"
                  responsiveLayout="scroll">

                  <ng-template pTemplate="header">
                    <tr>

                      <th pSortableColumn="lot.lotId" class="TEXTTH-w100">Lote <p-sortIcon field="lot.lotId">
                        </p-sortIcon>
                      </th>
                      <th pSortableColumn="group" class="TEXTTH-w100 th-wrap"
                        *ngIf="this.tender || this.award || (this.procurementprojectLot && this.procurementprojectAM) || this.contractModification">
                        Grupo <p-sortIcon field="group">
                        </p-sortIcon>
                      </th>
                      <th pSortableColumn="internalCode" class="TEXTTH-w200   th-wrap "
                        *ngIf="this.tender || this.procurementprojectLot || this.contractModification">Código
                        <p-sortIcon field="internalCode">
                        </p-sortIcon>
                      </th>
                      <th pSortableColumn="description" class="TEXTTH-w200   th-wrap ">Descripción <p-sortIcon
                          field="description">
                        </p-sortIcon>
                      </th>
                      <th pSortableColumn="complementaryOne" class="TEXTTH-w200  th-wrap"
                        *ngIf="this.tender || this.award || (this.procurementprojectLot && this.procurementprojectAM) || this.contractModification">
                        Descripcion adicional (1)
                        <p-sortIcon field="complementaryOne">
                        </p-sortIcon>
                      </th>
                      <th pSortableColumn="complementaryTwo" class="text-right TEXTTH-w200  th-wrap"
                        *ngIf="this.tender || this.award || (this.procurementprojectLot && this.procurementprojectAM) || this.contractModification">
                        Descripcion
                        adicional (2) <p-sortIcon field="complementaryTwo">
                        </p-sortIcon>
                      </th>
                      <th pSortableColumn="amount" *ngIf="this.procurementprojectLot && !this.procurementprojectAM"
                        class="CURRENCYTH  th-wrap "> Cantidad
                        <p-sortIcon field="amount">
                        </p-sortIcon>
                      </th>

                      <th *ngIf="this.tender || this.award || this.procurementprojectLot || this.contractModification"
                        pSortableColumn="amountExcludingTaxes" class="CURRENCYTH  th-wrap "> P.Unitario sin IVA
                        <p-sortIcon field="amountExcludingTaxes">
                        </p-sortIcon>
                      </th>
                      <th *ngIf="this.tender || this.award || this.procurementprojectLot || this.contractModification"
                        pSortableColumn="taxType.description" class="text-right TEXTTH-w200  th-wrap ">Tipo IVA
                        <p-sortIcon field="taxType.description">
                        </p-sortIcon>
                      </th>
                      <th *ngIf="this.procurementprojectLot && !this.procurementprojectAM" pSortableColumn="totalTaxes"
                        class="CURRENCYTH  th-wrap ">Cuantía IVA
                        <p-sortIcon field="totalTaxes">
                        </p-sortIcon>
                      </th>
                      <th *ngIf="this.procurementprojectLot && !this.procurementprojectAM" pSortableColumn="totalAmount"
                        class="CURRENCYTH  th-wrap ">P. Unitario con IVA
                        <p-sortIcon field="totalAmount">
                        </p-sortIcon>
                      </th>
                      <th *ngIf="this.tender" class="CURRENCYTH  th-wrap " pSortableColumn="tenderingPrice">P.
                        Licitación
                        sin IVA <p-sortIcon field="tenderingPrice">
                        </p-sortIcon>
                      </th>
                      <th *ngIf="this.tender" class="CURRENCYTH  th-wrap " pSortableColumn="lowPercentage">% Baja
                        <p-sortIcon field="lowPercentage">
                        </p-sortIcon>
                      <th
                        *ngIf="!this.tender && !this.award && !this.procurementprojectLot && !this.contractModification"
                        class="CURRENCYTH  th-wrap " pSortableColumn="unitPrice">
                        Precio unitario <p-sortIcon field="unitPrice">
                        </p-sortIcon>
                      </th>
                      <th class=" action-column-2"
                        *ngIf=" this.tender || this.procurementprojectLot || this.contractModification"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-element let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="element">
                      <td class="TEXTTH-w100" *ngIf="this.showLotes">
                        <formatDataValue [type]="'TEXT'"
                          [value]="element?.lot?.lotNumber?element.lot.lotNumber: element?.lot?.lotId === 0?'0':''">
                        </formatDataValue>
                        <!-- <p-cellEditor>
                        <ng-template pTemplate="input">
                          <formElement [model]="element" [fieldConfig]="getFieldConfig('lot')">
                          </formElement>
                        </ng-template>
                        <ng-template pTemplate="output"> -->
                        <!--<formatDataValue [type]="'TEXT'"
                            [value]="'#'+(element?.lot?.lotNumber?element.lot.lotNumber:'')">-->
                        <!-- <formatDataValue [type]="'TEXT'" [value]="(element?.lot?.lotNumber?element.lot.lotNumber:'')">
                          </formatDataValue>
                        </ng-template>
                      </p-cellEditor> -->
                      </td>
                      <td class="TEXTTH-w100" *ngIf="!this.showLotes">
                        <!--<formatDataValue [type]="'TEXT'" [value]="'#0'">-->
                        <formatDataValue [type]="'TEXT'" [value]="'0'">
                        </formatDataValue>
                      </td>
                      <td class="TEXTTH-w100"
                        *ngIf="this.tender || this.award || (this.procurementprojectLot && this.procurementprojectAM) || this.contractModification">
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <formElement [model]="element" [fieldConfig]="getFieldConfig('group')">
                            </formElement>
                          </ng-template>
                          <ng-template pTemplate="output">
                            <formatDataValue [type]="'TEXT'" [value]="element.group?element.group:''">
                            </formatDataValue>
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td class="TEXTTH-w100 "
                        *ngIf="this.tender || this.procurementprojectLot || this.contractModification">
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <formElement [model]="element" [fieldConfig]="getFieldConfig('internalCode')">
                            </formElement>
                          </ng-template>
                          <ng-template pTemplate="output">
                            <formatDataValue [type]="'TEXT'" [value]="element.internalCode?element.internalCode:''">
                            </formatDataValue>
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td class="TEXTTH-w200 ">
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <formElement [model]="element" [fieldConfig]="getFieldConfig('description')">
                            </formElement>
                          </ng-template>
                          <ng-template pTemplate="output">
                            <formatDataValue [type]="'TEXT'" [value]="element.description?element.description:''">
                            </formatDataValue>
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td class="TEXTTH-w200"
                        *ngIf="this.tender || this.award || (this.procurementprojectLot && this.procurementprojectAM)  || this.contractModification">
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <formElement [model]="element" [fieldConfig]="getFieldConfig('complementaryOne')">
                            </formElement>
                          </ng-template>
                          <ng-template pTemplate="output">
                            <formatDataValue [type]="'TEXT'"
                              [value]="element?.complementaryOne?element?.complementaryOne:''">
                            </formatDataValue>
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td class="TEXTTH-w200"
                        *ngIf="this.tender || this.award || (this.procurementprojectLot && this.procurementprojectAM)  || this.contractModification">
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <formElement [model]="element" [fieldConfig]="getFieldConfig('complementaryTwo')">
                            </formElement>
                          </ng-template>
                          <ng-template pTemplate="output">
                            <formatDataValue [type]="'TEXT'"
                              [value]="element?.complementaryTwo?element?.complementaryTwo:''">
                            </formatDataValue>
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td class="CURRENCYTH" *ngIf="this.procurementprojectLot && !this.procurementprojectAM">
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <formElement [model]="element" [fieldConfig]="getFieldConfig('amount')">
                            </formElement>
                          </ng-template>
                          <ng-template pTemplate="output">
                            <formatDataValue [type]="'INTEGER'" [value]="element?.amount?element?.amount:0">
                            </formatDataValue>
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td *ngIf="this.tender || this.award || this.procurementprojectLot || this.contractModification"
                        class="CURRENCYTH">
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <!--<formElement [model]="element" [fieldConfig]="getFieldConfig('amountExcludingTaxes')"
                            (onBlur)="onAmountExcludingTaxesChange($event, element)"
                            (mouseleave)="onAmountExcludingTaxesChange($event, element)">-->
                            <formElement [model]="element" [fieldConfig]="getFieldConfig('amountExcludingTaxes')"
                              (onBlur)="onAmountExcludingTaxesChange($event, element)"
                              (ngModelChange)="onAmountExcludingTaxesChange($event, element)">
                            </formElement>
                          </ng-template>
                          <ng-template pTemplate="output">
                            <formatDataValue [type]="'CURRENCY'"
                              [value]="element.amountExcludingTaxes?element.amountExcludingTaxes:0"
                              [maxDecimals]="this.PRECIOSUNITARIOS_NUMDECIMALES">
                            </formatDataValue>
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td *ngIf="this.tender || this.award || this.procurementprojectLot || this.contractModification"
                        class="TEXTTH-w200 text-right">
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <formElement [model]="element" [fieldConfig]="getFieldConfig('taxType')"
                              (valueChanged)="onTaxTypeChange($event, element)">
                            </formElement>
                          </ng-template>
                          <ng-template pTemplate="output">
                            <!--<formatDataValue
                            [value]="element?.taxType?.properties?.DESCRIPCION?element.taxType.properties.DESCRIPCION:''">
                          </formatDataValue>-->
                            <formatDataValue [value]="element?.taxType?.description?element.taxType.description:''">
                            </formatDataValue>
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td *ngIf="this.procurementprojectLot && !this.procurementprojectAM" class="CURRENCYTH">
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <formElement [model]="element" [fieldConfig]="getFieldConfig('totalTaxes')">
                            </formElement>
                          </ng-template>

                          <ng-template pTemplate="output">
                            <formatDataValue [type]="'CURRENCY'" [value]="element.totalTaxes?element.totalTaxes:0"
                              [maxDecimals]="this.PRECIOSUNITARIOS_NUMDECIMALES">
                            </formatDataValue>
                          </ng-template>
                        </p-cellEditor>
                      </td>

                      <td *ngIf="this.procurementprojectLot && !this.procurementprojectAM" class="CURRENCYTH">
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <formElement [model]="element" [fieldConfig]="getFieldConfig('totalAmount')">
                            </formElement>
                          </ng-template>
                          <ng-template pTemplate="output">
                            <formatDataValue [type]="'CURRENCY'" [value]="element.totalAmount?element.totalAmount:0"
                              [maxDecimals]="this.PRECIOSUNITARIOS_NUMDECIMALES">
                            </formatDataValue>
                            <!--<formatDataValue [type]="'CURRENCY'" [value]="getFieldValue(element,'totalAmount')"
                            [maxDecimals]="this.PRECIOSUNITARIOS_NUMDECIMALES">
                          </formatDataValue>-->

                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td *ngIf="this.tender &&  !this.procurementprojectLot && !this.contractModification"
                        class="CURRENCYTH">
                        <formatDataValue [type]="'CURRENCY'"
                          [value]="element.tenderingPrice!==undefined?element.tenderingPrice:''"
                          [maxDecimals]="this.PRECIOSUNITARIOS_NUMDECIMALES"
                          [valueClassObject]="'text-primary font-bold'">
                        </formatDataValue>
                      </td>
                      <td *ngIf="this.tender &&  !this.procurementprojectLot && !this.contractModification"
                        class="CURRENCYTH">
                        <formatDataValue [type]="'PERCENTAGE'"
                          [value]="element.lowPercentage!==undefined?element.lowPercentage:''" [maxDecimals]="3"
                          [valueClassObject]="'text-primary font-bold'">
                        </formatDataValue>
                      </td>
                      <td
                        *ngIf="!this.tender && !this.award && !this.procurementprojectLot && !this.contractModification"
                        class="CURRENCYTH">
                        <formatDataValue [type]="'CURRENCY'" [value]="element.unitPrice?element.unitPrice:''"
                          [maxDecimals]="this.PRECIOSUNITARIOS_NUMDECIMALES">
                        </formatDataValue>
                      </td>
                      <td class="action-column-2"
                        *ngIf="(this.tender || this.procurementprojectLot || this.contractModification) && !this.readOnly">
                        <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                          pTooltip="Editar" (click)="onRowEditInit(element, ri)"
                          class="p-button-rounded p-button-text"></button>
                        <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                          pTooltip="Confirmar edición" (click)="onRowEditSave(element,ri)"
                          class="p-button-rounded p-button-text"></button><!--  p-button-success p-mr-2-->
                        <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                          pTooltip="Cancelar edición" (click)="onRowEditCancel(element, ri)"
                          class="p-button-rounded p-button-text"></button>
                        <!--<button *ngIf="!editing" pButton pRipple type="button" icon="pi pi-times"
                        (click)="onRowDelete(element, ri)" class="p-button-rounded p-button-text"></button>-->
                        <button *ngIf="!editing" pButton pRipple type="button" icon="fas fa-trash-alt" pTooltip="Borrar"
                          (click)="onRowDelete(element, ri)" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
  </div>
</p-scrollPanel>
<p-dialog header="Baja porcentual" [(visible)]="this.visibleOptions" (onHide)="this.onCloseOptions()"
  (onShow)="this.onShowOptions()" [responsive]="true" [modal]="true" [resizable]="false" [closable]="true"
  [dismissableMask]="true" [closeOnEscape]="false" [blockScroll]="true" [style]="{'width':'50vw'}"
  [contentStyle]="{ 'max-height': '70vh', overflow: 'hidden'}">
  <sub-header [isModal]="true" [windowHash]="this.OptionsWindowHash" [includeContextHelp]="true"
    *ngIf="this.visibleOptions">
  </sub-header>
  <p-scrollPanel [style]="{width: '100%', height: '70vh'}" styleClass="custombar1">
    <div class="container-fluid pb-5">
      <div class="row">
        <div class="col-12 alert alert-info" style="  cursor: pointer;">
          <p-radioButton name="global" value="global"
            label="Baja porcentual global: obligatorio introducir un porcentaje." [(ngModel)]="selectedValue"
            inputId="global" class="p-1 d-inline">
          </p-radioButton>
          <div class="col-8 mt-2 ml-3">
            <label [attr.for]="globalPercentage" id="'globalPercentage_label' }}" class="d-inline">Porcentaje:
              <span>*</span>
            </label>
            <p-inputNumber mode="decimal" suffix="%" locale="de-DE" [minFractionDigits]="3" [maxFractionDigits]="3"
              [(ngModel)]="this.globalPercentage" id="globalPercentage" name="globalPercentage" type="text"
              placeholder="" class="plForm-element PERCENTAGE" [disabled]="false"
              [ngClass]="true ? 'EDITABLE d-inline' : 'NOEDITABLE'" autocomplete="new-password">
            </p-inputNumber>
          </div>
        </div>
        <!-- <div class="col-12 alert alert-info" style="  cursor: pointer;">
          <p-radioButton name="lote" value="lote"
            label="Baja porcentual por lote: obligatorio seleccionar un lote e introducir porcentaje."
            [(ngModel)]="selectedValue" inputId="lote" class="p-1 d-inline">
          </p-radioButton>
          <div class="col-8 mt-2 ml-3">
            <label [attr.for]="lotsArray" id="'lotes_label' }}" class="d-inline">Lote: <span>*</span>
            </label>
            <p-dropdown [options]="this.lotsArray" [(ngModel)]="this.selectedLot">
            </p-dropdown>
            <label [attr.for]="lotPercentage" id="'lotPercentage_label' }}" class="d-inline">Porcentaje: <span>*</span>
            </label>
            <p-inputNumber mode="decimal" suffix="%" locale="de-DE" [minFractionDigits]="3" [maxFractionDigits]="3"
              [(ngModel)]="this.lotPercentage" id="lotPercentage" name="lotPercentage" type="text" placeholder=""
              class="plForm-element PERCENTAGE" [disabled]="false" [ngClass]="true ? 'EDITABLE d-inline' : 'NOEDITABLE'"
              autocomplete="new-password">
            </p-inputNumber>
          </div>
        </div> -->
        <div class="col-12 alert alert-info" style="  cursor: pointer;">
          <p-radioButton name="grupo" value="grupo"
            label="Baja porcentual por grupo: obligatorio seleccionar un grupo e introducir un porcentaje. "
            [(ngModel)]="selectedValue" inputId="grupo" class="p-1 d-inline">
          </p-radioButton>
          <div class="col-8 mt-2 ml-3">
            <label [attr.for]="groupsArray" id="'groups_label' }}" class="d-inline">Grupo: <span>*</span>
            </label>
            <p-dropdown [options]="this.groupsArray" [(ngModel)]="this.selectedGroup">
            </p-dropdown>
            <label [attr.for]="groupPercentage" id="'groupPercentage_label' }}" class="d-inline">Porcentaje:
              <span>*</span>
            </label>
            <p-inputNumber mode="decimal" suffix="%" locale="de-DE" [minFractionDigits]="3" [maxFractionDigits]="3"
              [(ngModel)]="this.groupPercentage" id="groupPercentage" name="groupPercentage" type="text" placeholder=""
              class="plForm-element PERCENTAGE" [disabled]="false" [ngClass]="true ? 'EDITABLE d-inline' : 'NOEDITABLE'"
              autocomplete="new-password">
            </p-inputNumber>
          </div>
        </div>
      </div>
    </div>
  </p-scrollPanel>
</p-dialog>